import { useQuery } from 'react-query';

import { useAuth } from '@/lib/hooks/useAuth';
import { apiGetUserPoints } from '@/services/user.api';
import { useUserStore } from '@/store';

export function useWalletBalance() {
  const { isAuthenticated } = useAuth();
  const { user } = useUserStore()

  const email  = user?.email

  const { data:pointsData ,isLoading } = useQuery({
    queryKey: ['twin-points'],
    queryFn: () => apiGetUserPoints({ email }),
    enabled: !!user && isAuthenticated,
    staleTime: 30000, 
    cacheTime: 5 * 60 * 1000, 
  });

  return {
    points: pointsData?.data?.data?.points || 0,
    isLoading,
  };

}
